import React from "react";
import { Construction } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function ModulePlaceholderPage({ meta }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Card className="max-w-lg text-center" data-testid="module-placeholder">
        <CardContent className="space-y-4 p-10">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent text-accent-foreground">
            <Construction className="h-7 w-7" />
          </div>
          <div className="space-y-1">
            <h2 className="font-heading text-xl font-bold">{meta?.label || "Módulo"}</h2>
            <p className="text-sm text-muted-foreground">
              Este módulo está previsto en la hoja de ruta.
            </p>
          </div>
          {meta?.iteration && (
            <Badge variant="secondary" className="text-xs" data-testid="placeholder-iteration">
              {meta.iteration}
            </Badge>
          )}
          <p className="text-xs text-muted-foreground">
            Los cimientos (acceso, roles y permisos) ya están operativos. Construiremos
            este módulo en su iteración correspondiente.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
